import { globalStyles } from "@client/shared/constants";
const { background, display, flex } = globalStyles;

const styles = {
  expiryWrapper: {
    cursor: "pointer",
  },
  expiryModal: {
    width: 420,
    height: 160,
  },
  dialogTitle: {
    ...display.flex,
    ...flex.align.center,
    ...flex.justify.between,
    backgroundColor: "grey.100",
    borderBottom: "1px solid",
    borderColor: "grey.300",
  },
  dialogContent: {
    ...display.flex,
    ...flex.align.center,
    marginBottom: 4,
    marginTop: 2,
  },
  actionBtns: {
    marginBottom: 4,
    marginRight: 4,
  },
  icon: {
    color: "black",
    ...flex.justify.end,
  },
  clockBtn: {
    marginRight: "8px",
  },
};

export default styles;
